// extracted by mini-css-extract-plugin
export default {"addTokenButtonWrapper":"ModalUserTokensUpdate_addTokenButtonWrapper__T8iaZ"};